import { StepShell, StepHeading } from "@codel/dova-ds";
import { Button } from "../components/Button";
import type { StepProps } from "../flowConfig";

const CARDS = [
  {
    title: "Check in before and after each session",
    body:
      "A moment to gather your thoughts beforehand, and a short reflection after while it's still fresh, to land the work rather than extend the session.",
  },
  {
    title: "Coach you in real time",
    body:
      "When tension rises between sessions, message Dova privately or as a couple. Dova helps you slow down, hear each other, and pick a next move that fits what you're working on.",
  },
  {
    title: "Handle the easy stuff",
    body:
      "Scheduling, rescheduling, questions about your plan, without chasing down email threads.",
  },
];

export function S7Preview({ onNext, onBack, currentStepIndex, totalSteps }: StepProps) {
  return (
    <StepShell
      showBack
      onBack={onBack}
      currentStep={currentStepIndex}
      totalSteps={totalSteps}
      footer={<Button onClick={onNext}>Continue</Button>}
    >
      <StepHeading title="How Dova works">
        Three ways Dova sits alongside your sessions.
      </StepHeading>

      <div className="flex flex-col gap-4">
        {CARDS.map((card) => (
          <div
            key={card.title}
            className="rounded-[var(--radius-md)] border border-[var(--border)] bg-[var(--surface)] p-4"
          >
            <h3 className="font-semibold text-[var(--text-primary)] mb-1">{card.title}</h3>
            <p className="text-base leading-[1.5] text-[var(--text-secondary)]">{card.body}</p>
          </div>
        ))}
      </div>
    </StepShell>
  );
}
